<template>
    <div class="login-root">
        <div class="logo-section">            
            <img class="logo-image" src="@/assets/full-logo-300w.png"/>
        </div>
        <div class="form-section">
            <div class="form-container">
                <div class="container">
                        <div class="row">
                            <template v-if="currentView == 'login'">                                                
                                <div class="col-md-4 offset-md-3">
                                    <form class="form">
                                        <div class="form-group">
                                            <label for="username">Username/email address:</label>
                                            <input id="username" type="email" class="form-control" v-model="username"/>
                                        </div>

                                        <div class="form-group">
                                            <label for="password">Password:</label>
                                            <input id="password" type="password" class="form-control" v-model="password" />
                                        </div>

                                        <div class="form-group">
                                            <input id="keepMeLoggedIn" type="checkbox" v-model="keepMeLoggedIn">&nbsp;<label for="keepMeLoggedIn">Keep me logged in</label>
                                        </div>

                                        <div class="form-group">
                                            <button :disabled="isLoggingIn == true" class="btn btn-primary" @click.prevent="loginClicked">Login</button>                                    
                                        </div>

                                        <div v-if="isLoggingIn" class="alert alert-info">Logging in, please wait...</div>
                                    </form>                            
                                </div>
                                <div class="col-md-2">
                                    <h5>Don't have an account?</h5>
                                    <p>
                                        Visit the <a href="https://www.extendweather.com/">ExtendWeather homepage</a> to sign-up for a free trial.
                                    </p>
                                </div>
                            </template>
                            <template v-if="currentView == 'restore'">
                                <div class="col-md-4 offset-md-4">
                                    <template v-if="userInfo != null">
                                        <h3 class="welcome-back-title">Welcome back, {{ userInfo.name }}</h3>
                                        <hr/>
                                        <p>
                                            <button class="btn btn-primary btn-block" @click="continueClicked">Continue</button>                                                                                        
                                            <button class="btn btn-secondary btn-block" @click="signInAnotherUserButtonClicked">Sign in as another user</button>
                                        </p>                                        
                                    </template>                                    
                                </div>
                            </template>
                    </div>
                </div>                               
            </div>
        </div>  
    </div>
</template>

<script>

import { ServiceController } from '@/lib/ServiceController.js'
import UserStorage from '@/lib/UserStorage.js'
import logger from '@/lib/logger.js'

export default {
    name: 'LoginView',
    data() {
        return {
            currentView: 'login',
            
            userInfo: null,
            
            username: '',
            password: '',
            keepMeLoggedIn: false,
            
            isLoggingIn: false            
        }
    },
    methods: {
        loginClicked() {
            this.isLoggingIn = true
            ServiceController.login(this.username, this.password, this.keepMeLoggedIn, () => { 
                this.isLoggingIn = false 
            })
        },
        signInAnotherUserButtonClicked() {
            this.userInfo = null
            this.currentView = 'login'
        },
        continueClicked() {   
            this.$store.commit('setUser', this.userInfo)
        }
    },
    mounted() {
        logger.log('LoginView::mounted()')

        if (UserStorage.hasUserToken()) {            
            logger.log('Previous token found, getting user data from user')
            this.currentView = 'restore'
            let usertoken = UserStorage.getUserToken()
            ServiceController.getUserInfo(usertoken, 
                (userInfo) => {
                    this.userInfo = userInfo
                }, 
                () => {
                    this.currentView = 'login'
                }
            )
        }
        else {
            logger.log('No previous user token found')
        }
    }
}
</script>

<style>
.login-root {
    display: flex;
    flex-direction: column;   
    height: 100%;
}

.login-root .logo-section {
    flex: 1;
    position: relative;
    min-height: 125px;
}

.login-root .logo-section .logo-image {
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -150px;
}

.login-root .form-section {
    flex: 2;
    background-color: #f0f0f0;    
}

.login-root .form-section .form-container {
    margin-top: 2em;
}

.welcome-back-title {
    text-align: center;
}
</style>
